import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

/* read-only here: employees see which region applies to them, admins assign it */
const getHolidayRegionListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const res = await api.get.holidayCalendar.regions();
		const content = res.map(({ region, regionCode, ...o }) => ({ label: region || regionCode, value: regionCode, ...o }));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getHolidayRegionListing;
